import styled from '@emotion/styled';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';
import { Button, Divider } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { overseaTranslate } from 'services/api/overseaTranslate';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { LoadingOutlined, ReloadOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';

function FaqBotRequestText(props: BaseMsgProps) {
  const { faqBotRequestTextContent } = props.raw;

  const { t } = useTranslate();

  const lang = useSystemLanguageValue();

  const [loading, setLoading] = useState(true);
  const [translated, setTranslated] = useState<string>();

  const translate = useCallback(() => {
    if (!faqBotRequestTextContent?.text) {
      return;
    }
    setLoading(true);
    overseaTranslate(faqBotRequestTextContent?.text, lang, 'chat')
      .then(setTranslated)
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  }, [lang, faqBotRequestTextContent?.text]);

  useEffect(() => {
    translate();
  }, [translate]);

  if (!faqBotRequestTextContent) {
    return <></>;
  }

  return (
    <MessageExtendComplex
      {...props}
      content={
        <Container>
          <div>{faqBotRequestTextContent.text}</div>
          <Divider />
          <div>
            {loading ? (
              <LoadingOutlined />
            ) : (
              translated || (
                <Button type="link" icon={<ReloadOutlined />} onClick={translate}>
                  {t('Entities.翻译失败')}
                </Button>
              )
            )}
          </div>
        </Container>
      }
    />
  );
}

const Container = styled.div`
  max-width: 450px;
  padding: 8px 12px;
  border-radius: 4px;
  background: #fff;
  .ant-divider {
    margin: 8px 0;
  }
`;

export default FaqBotRequestText;
